import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import {
  BorderRadiusThemePropsSchema,
  BorderThemePropsSchema,
  DropShadowSchema
} from './FlexSectionWidgetStaticSchema';
import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export enum NavigationOption {
  WithArrows = 'withArrows',
  WithIndicators = 'withIndicators'
}

export enum Layout {
  Overlay = 'overlay',
  Split = 'split'
}

export enum LayoutTextPosition {
  Top = 'top',
  Bottom = 'bottom',
  Right = 'right',
  Left = 'left',
  Full = 'full'
}

const CarouselSlideSchema = z.object({
  id: z.string(),
  layout: z.nativeEnum(Layout),
  layoutTextPosition: z.nativeEnum(LayoutTextPosition),
  textContainerElements: z.object({
    withText: z.boolean(),
    withAudio: z.boolean()
  }),
  textContainerSpace: z.number(),
  mediaElement: z.enum(['Image', 'Embed']).nullable(),
  text: z.object({
    fragment: ProseMirrorJSONSchema
  }),
  textStyle: z.object({
    width: z.number().nullable(),
    style: z.record(z.unknown())
  }),
  mediaStyle: z.object({
    width: z.number(),
    height: z.number(),
    usesDefaultStyle: z.boolean()
  }),
  image: z.object({
    src: z.string(),
    alt: z.string(),
    mobileSrc: z.string(),
    objectFit: z.string(),
    mobileObjectFit: z.string(),
    shouldFillContainer: z.boolean()
  }),
  embed: z.object({
    title: z.string(),
    src: z.string()
  }),
  audio: z.object({
    title: z.string(),
    src: z.string()
  }),
  style: z.record(z.unknown())
});

export const CarouselWidgetStaticSchema = BaseWidgetSchema(WidgetType.Carousel).extend({
  children: z.array(z.string()).optional(), // `children` is optional because it is not used in the Carousel's `create` function
  slidesOrder: z.array(z.string()),
  slides: z.record(z.string(), CarouselSlideSchema),
  navigationOptions: z.array(z.nativeEnum(NavigationOption)),
  isLooping: z.boolean(),
  style: z.object({
    dropShadow: DropShadowSchema.optional().nullable(),
    border: BorderThemePropsSchema.optional().nullable(),
    borderRadius: BorderRadiusThemePropsSchema.optional().nullable()
  })
});

export type CarouselWidgetStaticSchemaType = z.infer<typeof CarouselWidgetStaticSchema>;
export type CarouselSlideStaticType = z.infer<typeof CarouselSlideSchema>;
